/**
 * Generates a hash code from a string
 * @param str The string to generate a hash from
 */
export default function hashCode(str: string) {
  return str.split('').reduce((a, b) => {
    a = (a << 5) - a + b.charCodeAt(0);
    return a & a;
  }, 0);
}
